/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casmanagement_Filters_Template_All1Inputs */

const en_settings_casmanagement_filters_template_all1 = /** @type {(inputs: Settings_Casmanagement_Filters_Template_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All templates`)
};

/**
* | output |
* | --- |
* | "All templates" |
*
* @param {Settings_Casmanagement_Filters_Template_All1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casmanagement_filters_template_all1 = /** @type {((inputs?: Settings_Casmanagement_Filters_Template_All1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casmanagement_Filters_Template_All1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casmanagement_filters_template_all1(inputs)
});
export { settings_casmanagement_filters_template_all1 as "settings_casManagement_filters_template_all" }